import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { ContactPreviewProvider } from './context/ContactPreviewContext';
import Layout from './components/Layout/Layout';
import QuotaModal from './components/UI/QuotaModal';
import ContactPreviewPanel from './components/UI/ContactPreviewPanel';
import Dashboard from './pages/Dashboard';
import Astuces from './pages/Astuces';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import Birthdays from './pages/Birthdays';
import Campaigns, { NewCampaign } from './pages/Campaigns';
import Strategy from './pages/Strategy';
import Analytics from './pages/Analytics';
import Templates from './pages/Templates';
import Messages from './pages/Messages';
import Onboarding from './pages/Onboarding';
import Studio from './pages/Studio';
import ExpertGate from './components/ExpertGate';
import Import from './pages/Import';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import LandingPagePublic from './pages/LandingPagePublic';
import Acquisition from './pages/Acquisition';
import TestSuite from './pages/TestSuite';

import './styles/theme.css';

function QuotaModalWrapper() {
  const { quotaError, dismissQuotaError } = useApp();
  return <QuotaModal quota={quotaError} onClose={dismissQuotaError} />;
}

function PrivateRoute({ children, bare = false }) {
  const { isAuthenticated, authLoading } = useApp();

  if (authLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg, #F8F7FF)', flexDirection: 'column', gap: 16 }}>
        <div style={{ width: 40, height: 40, border: '4px solid #EDE9FF', borderTopColor: '#5A35FF', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <span style={{ color: '#6B7280', fontSize: 14 }}>Chargement…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (bare) return children;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <ContactPreviewProvider>
        <QuotaModalWrapper />
        <ContactPreviewPanel />
        <Routes>
          <Route path="/login"          element={<Login />} />
          <Route path="/register"       element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/lp/:slug"       element={<LandingPagePublic />} />
          <Route path="/test"           element={<TestSuite />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          <Route path="/onboarding"   element={<PrivateRoute bare><Onboarding /></PrivateRoute>} />
          <Route path="/dashboard"    element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/astuces"      element={<PrivateRoute><Astuces /></PrivateRoute>} />
          <Route path="/contacts"     element={<PrivateRoute><Contacts /></PrivateRoute>} />
          <Route path="/contacts/:id" element={<PrivateRoute><ContactDetail /></PrivateRoute>} />
          <Route path="/birthdays"    element={<PrivateRoute><Birthdays /></PrivateRoute>} />
          <Route path="/campaigns"    element={<PrivateRoute><Campaigns /></PrivateRoute>} />
          <Route path="/campaigns/new" element={<PrivateRoute><NewCampaign /></PrivateRoute>} />
          <Route path="/messages"     element={<PrivateRoute><Messages /></PrivateRoute>} />
          <Route path="/strategy"     element={<PrivateRoute><ExpertGate><Strategy /></ExpertGate></PrivateRoute>} />
          {/* Analytics ouvert à tous (option A) : la BI est un argument de vente */}
          <Route path="/analytics"    element={<PrivateRoute><Analytics /></PrivateRoute>} />
          <Route path="/studio"       element={<PrivateRoute><ExpertGate><Studio /></ExpertGate></PrivateRoute>} />
          <Route path="/templates"    element={<Navigate to="/studio" replace />} />
          <Route path="/imports"      element={<PrivateRoute><Import /></PrivateRoute>} />
          <Route path="/collecte"     element={<PrivateRoute><Acquisition /></PrivateRoute>} />
          <Route path="/settings"     element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/settings/:tab" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/admin"        element={<PrivateRoute><Admin /></PrivateRoute>} />
          {/* Route de secours : toute URL inconnue renvoie au dashboard (plus de page blanche) */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </ContactPreviewProvider>
      </AppProvider>
    </BrowserRouter>
  );
}
